import { useState } from 'react';
import { motion } from 'framer-motion';
import DatePicker from 'react-datepicker';
import TimePicker from 'react-time-picker';
import { fadeIn, reservationData } from '../utils';
import { FaUsers, FaCalendar, FaClock } from 'react-icons/fa';
import "react-datepicker/dist/react-datepicker.css";
import 'react-time-picker/dist/TimePicker.css';
import 'react-clock/dist/Clock.css';
import './timepicker.css';

export const Reservation = () => {
  const { title, subtitle, modelImg, btnText } = reservationData;

  const [startDate, setStartDate] = useState<Date | null>(new Date());
  const [clock, setClock] = useState<any>('19:30');
  const [people, setPeople] = useState<number>(2);

  return (
    <section className='relative top-96 z-30 pb-20 lg:py-[100px]'>
      <div id='reservations' className="container mx-auto">
        <motion.div
          initial='hidden'
          whileInView='show'
          className='text-center'
        >
          <motion.h2 variants={fadeIn('up', 'tween', 0.2, 1.6)} className='h2 capitalize'>{title}</motion.h2>

          <motion.p variants={fadeIn('up', 'tween', 0.4, 1.6)} className='mb-8 text-dark'>{subtitle}</motion.p>

          <motion.div variants={fadeIn('up', 'tween', 0.6, 1.6)} className='flex justify-center mb-8'>
            <img src={modelImg} alt={title} />
          </motion.div>
        </motion.div>

        <motion.form
          variants={fadeIn('up', 'tween', 0.7, 1.6)}
          initial='hidden'
          whileInView='show'
        >
          <div className='flex flex-col lg:flex-row gap-y-4 items-center justify-between mb-8'>
            <div>
              <div className='flex items-center gap-x-[10px] font-semibold text-dark text-base mb-3'>
                <FaCalendar />

                <div>Choose Date</div>
              </div>

              <DatePicker
                className='input'
                selected={startDate}
                onChange={(date) => setStartDate(date)}
              />
            </div>

            <div>
              <div className='flex items-center gap-x-[10px] font-semibold text-dark text-base mb-3'>
                <FaClock />

                <div>Choose Time</div>
              </div>

              <TimePicker
                className='input'
                clearIcon={false}
                clockIcon={false}
                onChange={setClock}
                value={clock}
              />
            </div>

            <div>
              <div className='flex items-center gap-x-[10px] font-semibold text-dark text-base mb-3'>
                <FaUsers />

                <div>How many people?</div>
              </div>

              <input
                className='input'
                type="number"
                placeholder='2'
                min={1}
                max={18}
                value={people}
                onChange={(val) => setPeople(Number(val.target.value))}
              />
            </div>
          </div>

          <div className='max-w-[316px] mx-auto flex justify-center'>
            <button className="btn capitalize w-full lg:w-auto">{btnText}</button>
          </div>
        </motion.form>
      </div>
    </section>
  );
};
